import { BorderGridContainer, GridBox } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import { useSelector } from 'react-redux';
import React from 'react';

import { VARIANT } from '../../../../components/offers/tile/constants';
import data from '../../data';
import OfferTile from '../../../../components/offers/tile';
import selectCustomer from '../../../../selectors/select-customer';
import type { Offer, Placeholder } from '../../../../components/offers/types';

type OfferSectionProps = {
  offers: Offer[];
  placeholders: Placeholder[];
};

const OfferSection = ({ offers, placeholders }: OfferSectionProps) => {
  const customer = useSelector(selectCustomer);

  const hasActiveOffers = !isEmpty(offers);
  if (!hasActiveOffers) {
    return null;
  }

  const productType = customer?.productType;

  return (
    <BorderGridContainer hideBorderTop>
      <GridBox padding="1rem">
        <OfferTile
          // @ts-expect-error - Automatic, Please fix when editing this file
          filterProductId={data.filterProductId[productType] || data.filterProductId.DEFAULT}
          isBoxed={false}
          overrideOffers={offers}
          placeholders={placeholders}
          variant={VARIANT.STRIP}
        />
      </GridBox>
    </BorderGridContainer>
  );
};

export default OfferSection;
